// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dUDA","col":"styles_col__YqRmg"};